import { Component } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UsuarioService} from "../../../services/usuario-service";
import {ToastrService} from "ngx-toastr";
import {Router} from "@angular/router";
import {NovoUsuario} from "../../../models/novo-usuario";
import Swal from "sweetalert2";
import {Observable, of} from "rxjs";

@Component({
    selector: 'app-novo',
    templateUrl: './novo.component.html',
    styleUrl: './novo.component.css',
    standalone: false
})
export class NovoComponent {
  loading = true;
  formCadastrar: FormGroup;
  usuario = new NovoUsuario();
  listaTipoUsuario: Array<{id: number, descricao: string}>;

  constructor(private usuarioService: UsuarioService,
              private toastr: ToastrService,
              private formBuilder: FormBuilder,
              private router: Router) {
    this.construirFormulario();
    this.listaTipoUsuario = this.buscarTipoUsuario();
  }

  preencherModelo(){
    this.usuario.nome = this.formCadastrar.controls['nome'].value;
    this.usuario.email = this.formCadastrar.controls['email'].value;
    this.usuario.senha = this.formCadastrar.controls['senha'].value;
    this.usuario.confirmacaoSenha = this.formCadastrar.controls['confirmacaoSenha'].value;
    this.usuario.tipo = this.formCadastrar.controls['tipo'].value;
  }

  salvar(){
    this.validarFormulario();
    if(this.formCadastrar.invalid){
      this.toastr.error("Formulário inválido, verifique os campos");
      return;
    }
    Swal.fire({
      title: 'Deseja realmente salvar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: 'var(--primary-color)',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if(result.isConfirmed){
        this.loading = true;
        this.preencherModelo();
        this.usuarioService.adicionar(this.usuario).subscribe(
          (response) => {
            this.loading = false;
            if (response.sucesso) {
              this.toastr.success("Usuário salvo com sucesso");
              this.router.navigateByUrl('/gestao/usuario');
            } else {
              this.toastr.error("Erro ao salvar usuário - " + response.errors[0].mensagem);
            }
          },
          (error) => {
            if(error.status === 500){
              this.toastr.error(error.error);
            }
            this.toastr.error(error.erros[0].mensagem);
          }
        );
      }
    });
  }

  voltar(){
    this.router.navigateByUrl('/gestao/usuarios');
  }

  private construirFormulario(){
    this.formCadastrar = this.formBuilder.group({
      nome: [this.usuario.nome, [Validators.required]],
      email: [this.usuario.email, [Validators.required, Validators.email]],
      senha: [this.usuario.senha, [Validators.required]],
      confirmacaoSenha: [this.usuario.confirmacaoSenha, [Validators.required]],
      tipo: [this.usuario.tipo, [Validators.required]]
    });

    this.loading = false;
  }

  private validarFormulario(){
    Object.keys(this.formCadastrar.controls).forEach(name => {
      const control = this.formCadastrar.controls[name];
      control.markAsDirty();
      control.markAsTouched();
      control.updateValueAndValidity();
    });
  }

  private buscarTipoUsuario() {
    return [{ id: 0, descricao: 'Administrador' }, { id: 1, descricao: 'Gestor administrador' },
       { id: 2, descricao: 'Gestor' }, { id: 3, descricao: 'Assistente' },
       { id: 4, descricao: 'Cliente' }, { id: 6, descricao: 'SDR' }
    ];
  }
}
